import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8eb82630"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container ActiveDetail"
};
const _hoisted_2 = {
  class: "bottom-box"
};
const _hoisted_3 = {
  class: "filters"
};
const _hoisted_4 = {
  class: "filtersbox"
};
const _hoisted_5 = {
  class: "filtersarrow"
};
const _hoisted_6 = {
  class: "table-wrap"
};
const _hoisted_7 = {
  class: "table-head table-row"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-col-item flex1"
}, "城市", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-col-item"
}, "应活跃", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-col-item"
}, "已活跃", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-col-item"
}, "未活跃", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-col-item"
}, "活跃完成", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-col-item"
}, "活跃率", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-col-item"
}, "已活跃", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-col-item"
}, "活跃完成", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-col-item"
}, "活跃合格", -1));
const _hoisted_17 = {
  class: "table-row province"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-col-item flex1",
  style: {
    "padding-left": "calc(16px + 0.1rem)"
  }
}, "全部", -1));
const _hoisted_19 = {
  class: "table-col-item"
};
const _hoisted_20 = {
  class: "table-col-item"
};
const _hoisted_21 = {
  class: "table-col-item"
};
const _hoisted_22 = {
  class: "table-col-item"
};
const _hoisted_23 = {
  class: "table-col-item"
};
const _hoisted_24 = {
  class: "table-col-item"
};
const _hoisted_25 = {
  class: "table-col-item"
};
const _hoisted_26 = {
  class: "table-col-item"
};
const _hoisted_27 = {
  class: "table-row province"
};
const _hoisted_28 = {
  class: "table-col-item flex1"
};
const _hoisted_29 = {
  class: "table-col-item"
};
const _hoisted_30 = {
  class: "table-col-item"
};
const _hoisted_31 = {
  class: "table-col-item"
};
const _hoisted_32 = {
  class: "table-col-item"
};
const _hoisted_33 = {
  class: "table-col-item"
};
const _hoisted_34 = {
  class: "table-col-item"
};
const _hoisted_35 = {
  class: "table-col-item"
};
const _hoisted_36 = {
  class: "table-col-item"
};
const _hoisted_37 = {
  class: "table-col-item flex1"
};
const _hoisted_38 = {
  class: "table-col-item"
};
const _hoisted_39 = {
  class: "table-col-item"
};
const _hoisted_40 = {
  class: "table-col-item"
};
const _hoisted_41 = {
  class: "table-col-item"
};
const _hoisted_42 = {
  class: "table-col-item"
};
const _hoisted_43 = {
  class: "table-col-item"
};
const _hoisted_44 = {
  class: "table-col-item"
};
const _hoisted_45 = {
  class: "table-col-item"
};
const _hoisted_46 = {
  class: "chart-container"
};
const _hoisted_47 = {
  class: "bottombtn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_Selector = _resolveComponent("Selector");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_collapse_item = _resolveComponent("van-collapse-item");
  const _component_van_collapse = _resolveComponent("van-collapse");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_area_stacked_chart = _resolveComponent("area-stacked-chart");
  const _component_van_tabs = _resolveComponent("van-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_field, {
    modelValue: $data.date,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.date = $event),
    "is-link": "",
    readonly: "",
    label: "日期",
    onClick: _cache[1] || (_cache[1] = $event => $data.showPicker = true)
  }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
    show: $data.showPicker,
    "onUpdate:show": _cache[3] || (_cache[3] = $event => $data.showPicker = $event),
    round: "",
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_datetime_picker, {
      type: "date",
      title: "选择日期",
      "min-date": $options.minDate,
      "max-date": $options.maxDate,
      onCancel: _cache[2] || (_cache[2] = $event => $data.showPicker = false),
      onConfirm: $options.onConfirm
    }, null, 8, ["min-date", "max-date", "onConfirm"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_tabs, {
    active: $data.activeName,
    "onUpdate:active": _cache[7] || (_cache[7] = $event => $data.activeName = $event),
    "title-active-color": "#3875C6",
    "title-inactive-color": "#666",
    color: "#3875C6",
    class: "custom-tabs",
    onChange: $options.tabChange
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tab, {
      title: "统计表",
      name: "1",
      "title-class": "titletab",
      "title-style": "font-size: .28rem;line-height: 0.36rem;font-weight: 600;"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_Selector, {
        class: "selector",
        value: $data.province,
        "onUpdate:value": _cache[4] || (_cache[4] = $event => $data.province = $event),
        options: $data.provinceList,
        title: "省",
        onChange: $options.getCity
      }, null, 8, ["value", "options", "onChange"]), _createVNode(_component_Selector, {
        class: "selector",
        value: $data.city,
        "onUpdate:value": _cache[5] || (_cache[5] = $event => $data.city = $event),
        options: $data.cityList,
        title: "市",
        onChange: $options.getData1
      }, null, 8, ["value", "options", "onChange"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_icon, {
        name: "arrow"
      })])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, $data.tableData.prjCategory === 'DP' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_hoisted_9, _hoisted_10, _hoisted_11, _hoisted_12, _hoisted_13], 64)) : _createCommentVNode("", true), $data.tableData.prjCategory === 'LHDG' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_14, _hoisted_15, _hoisted_16], 64)) : _createCommentVNode("", true)]), _createVNode(_component_van_collapse, {
        modelValue: $data.activeNames,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.activeNames = $event),
        style: {
          "--van-collapse-item-content-padding": "0"
        }
      }, {
        default: _withCtx(() => [$data.tableData.isTotal ? (_openBlock(), _createBlock(_component_van_collapse_item, {
          key: 0,
          name: "全部",
          readonly: ""
        }, {
          title: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_hoisted_18, $data.tableData.prjCategory === 'DP' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("div", _hoisted_19, _toDisplayString($data.totalStatics.attExpect), 1), _createElementVNode("div", _hoisted_20, _toDisplayString($data.totalStatics.attDayDP), 1), _createElementVNode("div", _hoisted_21, _toDisplayString($data.totalStatics.attNot), 1), _createElementVNode("div", _hoisted_22, _toDisplayString($data.totalStatics.attEndDp), 1), _createElementVNode("div", _hoisted_23, _toDisplayString($data.totalStatics.attPassRate) + "%", 1)], 64)) : _createCommentVNode("", true), $data.tableData.prjCategory === 'LHDG' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("div", _hoisted_24, _toDisplayString($data.totalStatics.attDayLHDG), 1), _createElementVNode("div", _hoisted_25, _toDisplayString($data.totalStatics.attEndLHDG), 1), _createElementVNode("div", _hoisted_26, _toDisplayString($data.totalStatics.attQua), 1)], 64)) : _createCommentVNode("", true)])]),
          _: 1
        })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.provinces, item => {
          return _openBlock(), _createBlock(_component_van_collapse_item, {
            key: item.province,
            name: item.province
          }, {
            title: _withCtx(() => [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, _toDisplayString(item.province), 1), $data.tableData.prjCategory === 'DP' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createElementVNode("div", _hoisted_29, _toDisplayString(item.attExpect), 1), _createElementVNode("div", _hoisted_30, _toDisplayString(item.attDayDP), 1), _createElementVNode("div", _hoisted_31, _toDisplayString(item.attNot), 1), _createElementVNode("div", _hoisted_32, _toDisplayString(item.attEndDp), 1), _createElementVNode("div", _hoisted_33, _toDisplayString(item.attPassRate) + "%", 1)], 64)) : _createCommentVNode("", true), $data.tableData.prjCategory === 'LHDG' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_createElementVNode("div", _hoisted_34, _toDisplayString(item.attDayLHDG), 1), _createElementVNode("div", _hoisted_35, _toDisplayString(item.attEndLHDG), 1), _createElementVNode("div", _hoisted_36, _toDisplayString(item.attQua), 1)], 64)) : _createCommentVNode("", true)])]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.citys, city => {
              return _openBlock(), _createElementBlock("div", {
                class: "table-row city",
                key: city.city
              }, [_createElementVNode("div", _hoisted_37, _toDisplayString(city.city), 1), $data.tableData.prjCategory === 'DP' ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_createElementVNode("div", _hoisted_38, _toDisplayString(city.attExpect), 1), _createElementVNode("div", _hoisted_39, _toDisplayString(city.attDayDP), 1), _createElementVNode("div", _hoisted_40, _toDisplayString(city.attNot), 1), _createElementVNode("div", _hoisted_41, _toDisplayString(city.attEndDp), 1), _createElementVNode("div", _hoisted_42, _toDisplayString(city.attPassRate) + "%", 1)], 64)) : _createCommentVNode("", true), $data.tableData.prjCategory === 'LHDG' ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 1
              }, [_createElementVNode("div", _hoisted_43, _toDisplayString(city.attDayLHDG), 1), _createElementVNode("div", _hoisted_44, _toDisplayString(city.attEndLHDG), 1), _createElementVNode("div", _hoisted_45, _toDisplayString(city.attQua), 1)], 64)) : _createCommentVNode("", true)]);
            }), 128))]),
            _: 2
          }, 1032, ["name"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), !$data.provinces || $data.provinces.length === 0 ? (_openBlock(), _createBlock(_component_van_empty, {
        key: 0,
        description: "暂无数据"
      })) : _createCommentVNode("", true)])])]),
      _: 1
    }), _createVNode(_component_van_tab, {
      title: "统计图",
      name: "2",
      "title-class": "titletab",
      "title-style": "font-size: .28rem;line-height: 0.36rem;font-weight: 600;"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_46, [_createVNode(_component_area_stacked_chart, {
        data: $data.graphData,
        id: "chart",
        ref: "chart"
      }, null, 8, ["data"])])]),
      _: 1
    })]),
    _: 1
  }, 8, ["active", "onChange"]), _createElementVNode("div", _hoisted_47, [_createElementVNode("button", {
    class: "btn1",
    onClick: _cache[8] || (_cache[8] = (...args) => $options.goback && $options.goback(...args))
  }, "返回")])]);
}